var a = { icon: { tag: "svg", attrs: { viewBox: "0 0 16 16", focusable: "false", fill: "currentColor" }, children: [{ tag: "path", attrs: { d: "M1 8h2a1 1 0 011 1v6a1 1 0 01-1 1H1a1 1 0 01-1-1V9a1 1 0 011-1zm6-8h2a1 1 0 011 1v14a1 1 0 01-1 1H7a1 1 0 01-1-1V1a1 1 0 011-1zm6 3h2a1 1 0 011 1v11a1 1 0 01-1 1h-2a1 1 0 01-1-1V4a1 1 0 011-1z", "fill-rule": "evenodd" } }] }, name: "chart", theme: "filled" };
export {
  a as default
};
